import Vue from 'vue'
import Router from 'vue-router'
import store from '@/stores'
import authService from '@/services/authService'
// Pages
import customerRoutes from '@/router/customer.js'
import researchRoutes from '@/router/research.js'

Vue.use(Router)

let routes = []
if (process.env.APP_TYPE === 'RESEARCH') {
  routes = researchRoutes
} else {
  routes = customerRoutes
}

const router = new Router({
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes
})

router.beforeEach((to, from, next) => {
  if (authService.isLoggedIn()) {
    if (store.state.GET_USER_RESPONSE === null) {
      store.dispatch('getUser')
        .then(response => {
          const userDetails = response.data
          if (userDetails.underAge === true && userDetails.parentConsented !== true && to.path !== '/profile') {
            next('/profile')
            return
          }
        })
    } else {
      const userDetails = store.state.GET_USER_RESPONSE
      if (userDetails.underAge === true && userDetails.parentConsented !== true && to.path !== '/profile') {
        next('/profile')
        return
      }
    }
  }

  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js